import { capitalize } from 'lodash';

import { DatasetHistory } from 'hooks/data/datasets/types';

import HistoryEntry, { ReleaseDatasets } from './HistoryEntry';

type Props = {
  datasetHistory: DatasetHistory;
  version: string;
  isLast: boolean;
};

const DatasetHistoryTimelineRow = ({ datasetHistory, version, isLast }: Props) => {
  const item = datasetHistory[version];
  const sources: ReleaseDatasets[] = item.from_
    ? [{ version: item.predecessor, label: 'Source Dataset(s)', datasets: item.from_ }]
    : [];

  return (
    <>
      <HistoryEntry
        version={version}
        title={capitalize(item.status_short)}
        description={item.status_long}
        groups={[{ version, label: 'Resulting Dataset(s)', datasets: item.to }, ...sources]}
        hasDetails={item.to.length > 1 || (item.from_?.length ?? 0) > 1}
        hasConnector={item.from_ !== null}
      />
      {isLast && item.from_ !== null && (
        <HistoryEntry
          version={item.predecessor}
          title="Dataset available"
          description={`Dataset available in ${item.predecessor}`}
          groups={sources}
          hasDetails={item.from_.length > 1}
          hasConnector={false}
        />
      )}
    </>
  );
};

export default DatasetHistoryTimelineRow;
